export default "__VITE_ASSET__BkJehTM6__"